<template>
    <div :id="`${id}`">
        <span v-if="label">{{ label }}</span>
        <div
            class="placeholder__container"
            :class="{ 'has-error': !!errorMessage }"
        >
            <input
                v-model="searchText"
                type="text"
                class="custom-search-text"
                :id="`${id}-searchmultiselect`"
                :name="`${id}-searchmultiselect`"
                :placeholder="computedPlaceholder"
            />
            <em
                :class="{
                    'fas fa-chevron-down': !showList,
                    'fas fa-chevron-up': showList,
                }"
                style="color: rgba(60,60,60,0.5); font-weight: bold"
            />
        </div>
        <div
            v-if="showList"
            class="list-options__container"
        >
            <div
                v-for="(option, index) in computedOptions"
                :key="option.id"
                class="option-item__container"
                :class="{ 'multiselect-item-bg__gray': index % 2 == 0 }"
                @click="toggleOption(option)"
            >
                <div class="custom-control custom-checkbox">
                    <input
                        v-model="option.checked"
                        :id="option.toString()"
                        type="checkbox"
                        class="custom-control-input"
                        :name="option.toString()"
                    />
                    <label class="custom-control-label font regular"></label>
                </div>
                <span>
                    {{ option.name }}
                    <b v-if="option.nameDetail">{{ option.nameDetail }}</b>
                </span>
            </div>
        </div>
        <Error
            v-if="errorMessage"
            variant="no-border"
            :message="errorMessage"
          />
    </div>
</template>

<script>
import Error from '@/components/common/Error';

export default {
    name: "CustomMultiSelect",
    components: {
        Error
    },
    props: {
        id: {
            type: String,
            default: 'multi-select-id'
        },
        value: {
            type: Array,
            default: () => ([])
        },
        options: {
            type: Array,
            default: () => ([])
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Seleccione'
        },
        errorMessage: {
            type: String,
            default: ''
        },
        autofeelPlaceholder: {
            type: Boolean,
            default: true
        },
    },
    data: () => ({
        model: [],
        isOpen: false,
        innerOptions: [],
        searchText: '',
    }),
    methods: {
        toggleOption(option) {
            const existentOption = this.value.find(x => x.id == option.id);
            if (!existentOption)
                return this.model = [...this.value, ...[option]];

            const index = this.value.indexOf(existentOption);
            return this.model = [...this.value.splice(index, 1)];
        },
        registerClickEvent() {
            window.addEventListener(
                'click',
                (e) => this.isOpen = document.getElementById(this.id)?.contains(e.target)
            );
        },
    },
    computed: {
        showList() {
            return this.isOpen || !!this.searchText;
        },
        computedPlaceholder() {
            if (!this.autofeelPlaceholder)
                return this.placeholder;
            
            return this.value?.length === 0 ? this.placeholder :
                `(${this.value?.length}) Seleccionado${this.value?.length > 1 ? 's' : ''}`;
        },
        computedOptions() {
            const checkableOptions = this.options.map(option => ({
                ...option,
                checked: !!this.value.find(x => x.id == option.id)
            }));

            if (!this.searchText)
                return checkableOptions;

            return checkableOptions.filter(x => `${x.name.toLowerCase()} ${x.nameDetail?.toLowerCase()}`.includes(this.searchText.toLowerCase()));
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                if (newValue.toString() === this.model.toString()) return;

                this.model = [...newValue];
            },
        },
        model: {
            deep: true,
            handler(newValue) {
                if (newValue.toString() === this.value.toString()) return;

                this.$emit('input', [...newValue]);
            },
        },
    },
    mounted() {
        this.registerClickEvent();
    }
};
</script>

<style scoped src="@/assets/css/component/checkbox.css"></style>

<style scoped>
.placeholder__container {
    padding: 7px 16px;
    border-radius: 5px;
    background-color: white;
    border: 1px #00000029 solid;
    color: #495057;
    opacity: 0.8;
    line-height: 1.6;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.has-error {
    border: 1px solid #ff0018;
}

.list-options__container {
    border-radius: 5px;
    background-color: white;
    border: 1px #00000029 solid;
}

.option-item__container {
    display: flex;
    padding: 7px 16px;
    border-bottom: 1px #00000029 solid;
}

.option-item__container:hover {
    background-color: #b2ebd5;
}

.multiselect-item-bg__gray {
  background-color: #f1f1f1;
}

.custom-search-text {
    color: #495057;
    width: 100%;
    outline: none;
    border: none;
}

.custom-search-text::placeholder {
    color: #495057;
    opacity: 0.8;
    line-height: 1.6;
}
</style>